import React from 'react';
import { ResponsivePie } from '@nivo/pie';

export type NivoPieData = { id: string; label: string; value: number; color: string };

const NivoPie = ({
  data,
  margin = { top: 40, right: 80, bottom: 80, left: 80 },
  type,
}: {
  data: Array<NivoPieData>;
  margin?: { top: number; right: number; bottom: number; left: number };
  type: 'PIE' | 'DOUGHNUT' | string;
}) => {
  return (
    <ResponsivePie
      data={data}
      margin={margin}
      innerRadius={type === 'DOUGHNUT' ? 0.5 : 0}
      padAngle={0.7}
      cornerRadius={3}
      activeOuterRadiusOffset={8}
      borderWidth={1}
      borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
      arcLinkLabelsSkipAngle={30}
      arcLinkLabelsTextColor="#333333"
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: 'color' }}
      arcLabelsSkipAngle={60}
      arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
      legends={[
        {
          anchor: 'bottom',
          direction: 'row',
          justify: false,
          translateX: 0,
          translateY: 56,
          itemsSpacing: 0,
          itemWidth: 75,
          itemHeight: 18,
          itemTextColor: '#999',
          itemDirection: 'top-to-bottom',
          itemOpacity: 1,
          symbolSize: 18,
          symbolShape: 'circle',
          effects: [
            {
              on: 'hover',
              style: {
                itemTextColor: '#000',
              },
            },
          ],
        },
      ]}
      colors={(d) => {
        return d.data.color as string;
      }}
    />
  );
};

export default NivoPie;
